import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const ColorButton = styled(Button)`
    color: white;
    background: ${props => props.csscolor[props.colorlevel || 400]};

    &:hover {
        background: ${props => props.csscolor[props.colorlevel + 100 || 500]};
    }
`

ColorButton.propTypes = {
    csscolor: PropTypes.object,
    colorlevel: PropTypes.number
}

ColorButton.defaultProps = {
    variant: 'raised'
}

export default ColorButton



// WEBPACK FOOTER //
// ./src/ColorButton.js